import { Link } from "react-router-dom";
import escudo from "../../../images/escudo.png";

function NotFoundHeader() {
    return (
        <section className="mb-12 flex flex-col items-center text-center py-16">
            <img src={escudo} alt="Escudo de Aguada" className="w-24 h-auto mb-8 opacity-40" />

            <p className="text-8xl md:text-9xl font-black text-white/10 leading-none mb-4 select-none">
                404
            </p>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 leading-tight border-l-4 border-red-500 pl-4 text-left">
                Página no encontrada
            </h1>

            <p className="text-base sm:text-lg font-medium text-slate-400 max-w-md leading-relaxed mb-8">
                La página que buscas no existe o fue movida. Revisá la URL o volvé al inicio.
            </p>

            <Link
                to="/"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 text-white font-bold px-6 py-3 rounded-lg transition-colors"
            >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                </svg>
                Volver al inicio
            </Link>
        </section>
    );
}

export default NotFoundHeader;
